'use strict';

class _User {
	_id = '';
	name = '';
	email = null;
	role = '';
	$promise = undefined;
}

export function AuthService($location, $http, $cookies, $q, appConfig, Util, User) 
{
	'ngInject';

	var safeCb = Util.safeCb;
	var currentUser = new _User();
	//var userRoles = appConfig.userRoles || [];
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	// Check if userRole is >= role
	// @param {String} userRole - role of current user
	// @param {String} role - role to check against
	//var hasRole = function(userRole, role) {
	// return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
	//};

	if ($cookies.get('token') && $location.path() !== '/logout') {
		currentUser = User.get();
	}

	var Auth = 
	{
		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Authenticate user and save token
		// @param  {Object}   user     - login info
		// @param  {Function} callback - function(error, user)
		// @return {Promise}
		login({ email, password }) 
		{
			return $http.post('/auth/local', {
				email,
				password
				//rememberme: true
			})
			.then(res => {
				// Setear la persitencia de la cookie
				//@{
				var expireDate = new Date();
				expireDate.setDate(expireDate.getDate() + 30);
				if (/*rememberme ===*/ true) {
					//console.log("Estableciendo persistencia de la cookie hasta :" + expireDate);
					$cookies.put('token', res.data.token, { 'expires': expireDate });
				}
				//@}
				/*else
				{
					$cookies.put('token', res.data.token);
				}*/

				currentUser = User.get();
				return currentUser.$promise;
			})
			.then(user => {
				return user;
			})
			.catch(err => {
				Auth.logout();
				return $q.reject(err);
			});
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Delete access token and user info
		logout() 
		{
			$cookies.remove('token');
			currentUser = new _User();
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Create a new user
		// @param  {Object}   user     - user info
		// @return {Promise}
		createUser(user) 
		{
			// Sergio: Creo el usuario pero no lo activo hasta que no verifique el correo
			// NOTE: Ojo con el logout mas abajo... no puedo devolver el promise que sale del http.post directamente
			var deferred = $q.defer();

			$http.post('/api/users/create', user)
			.then(response => {
				//$cookies.put('token', data.token);
				//currentUser = User.get();
				deferred.resolve(response);
			})
			.catch(error => {
				Auth.logout();
				deferred.reject(error);
			});

			return deferred.promise;
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Actualiza los campos de usuario desde su panel de control
		updateUser(fields) 
		{
			// NOTE: Se actualiza el currentUser aquí, asi que no puedo devolver el promise directamente
			var deferred = $q.defer();

			$http.post('/api/users/update', fields)
			.then(response => {
				currentUser = User.get();
				deferred.resolve(response);
			})
			.catch(error => {
				deferred.reject(error);
			});

			return deferred.promise;
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Envia una peticion de reseteo de contraseña
		resetPasswordRequest(email) 
		{
			return $http.post('/api/users/resetpasswordrequest', { email });
			/*var deferred = $q.defer();

			$http.post('/api/users/resetpasswordrequest', { email })
			.then(response => {
				deferred.resolve(response);
			})
			.catch(error => {
				deferred.reject(error);
			});

			return deferred.promise;*/
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		resetPassword(password, code) 
		{
			return $http.post('/api/users/resetpassword', { password, code });
			/*
			var deferred = $q.defer();

			$http.post('/api/users/resetpassword', { password, code })
			.then(response => {
				deferred.resolve(response);
			})
			.catch(error => {
				deferred.reject(error);
			});

			return deferred.promise;*/
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Envia una petición de reenvío del correo de verificación
		resendVerificationEmail(email) 
		{
			return $http.post('/api/users/resendverificationemail', { email });
			/*
			var deferred = $q.defer();

			$http.post('/api/users/resendverificationemail', { email })
			.then(response => {
				deferred.resolve(response);
			})
			.catch(error => {
				deferred.reject(error);
			});

			return deferred.promise;*/
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Comprueba si el correo introducido está registrado en la base de datos
		checkEmailExists(email)
		{
			return $http.post('/api/users/checkemailexists', { email });
			/*
			var deferred = $q.defer();

			$http.post('/api/users/checkemailexists', { email })
			.then(response => {
				deferred.resolve(response);
			})
			.catch(error => {
				deferred.reject(error);
			});

			return deferred.promise;*/
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Change password
		// @param  {String}   oldPassword
		// @param  {String}   newPassword
		// @param  {Function} callback    - function(error, user)
		// @return {Promise}
		changePassword(oldPassword, newPassword) 
		{
			/*
			return User.changePassword({
			  id: currentUser._id
			}, {
			  oldPassword,
			  newPassword
			}, function() {
			  return safeCb(callback)(null);
			}, function(err) {
			  return safeCb(callback)(err);
			})
			  .$promise;*/
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Gets all available info on a user
		// @param  {Function} [callback] - function(user)
		// @return {Promise}
		getCurrentUser(callback) 
		{
			var value = _.get(currentUser, '$promise') ? currentUser.$promise : currentUser;

			return $q.when(value)
				.then(user => {
					safeCb(callback)(user);
					return user;
				}, () => {
					safeCb(callback)({});
					return {};
				});
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Gets all available info on a user
		// @return {Object}
		getCurrentUserSync() {
			return currentUser;
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Check if a user is logged in
		// @param  {Function} [callback] - function(is)
		// @return {Promise}
		isLoggedIn(callback) 
		{
			return Auth.getCurrentUser(undefined)
			.then(user => {
				//let is = _.get(user, 'role');
				//let is = user.hasOwnProperty('email');
				let is = user.email !== null;
				safeCb(callback)(is);
				return is;
			});
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Check if a user is logged in
		// @return {Bool}
		isLoggedInSync() {
			//return !!_.get(currentUser, 'role');
			//return currentUser.hasOwnProperty('email');
			return currentUser.email !== null;
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Check if a user has a specified role or higher
		// @param  {String}     role     - the role to check against
		// @param  {Function} [callback] - function(has)
		// @return {Promise}
		/*hasRole(role, callback) {
			return Auth.getCurrentUser(undefined)
			.then(user => {
				let has = hasRole(_.get(user, 'role'), role);

				safeCb(callback)(has);
				return has;
			});
		},*/

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Check if a user has a specified role or higher
		// @param  {String} role - the role to check against
		// @return {Bool}
		/*hasRoleSync(role) {
			return hasRole(_.get(currentUser, 'role'), role);
		},*/

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Check if a user is an admin (synchronous|asynchronous)
		// @param  {Function|*} callback - optional, function(is)
		// @return {Bool|Promise}
		/*isAdmin() {
			return Auth.hasRole.apply(Auth, [].concat.apply(['admin'], arguments));
		},*/

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Check if a user is an admin
		// @return {Bool}
		/*isAdminSync() {
			return Auth.hasRoleSync('admin');
		},*/

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		// Get auth token
		// @return {String} - a token string used for authenticating
		getToken() {
			return $cookies.get('token');
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		isOrganizerSync()
		{
			return currentUser.is_organizer === true;
		},

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		isChampOrganizerSync()
		{
			return currentUser.is_champ_organizer === true;
		},
		
		////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		isAdminSync()
		{
			return currentUser.is_admin === true;
		}
	};

	return Auth;
}



// WEBPACK FOOTER //
// ./client/components/auth/auth.service.js